import BaseAction from "./BaseAction";
import ObservationsReducer from "@common/redux/reducers/ObservationsReducer";

class ObservationsAction extends BaseAction {
  onClose = () => {};

  open = async (data) => await this.dispatch({ ...data, open: true });
}

const action = new ObservationsAction(ObservationsReducer);

export default action;
